export default "__VITE_ASSET__CejjUHkk__"